var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3094",
    "data-name": "Rectangle 3094",
    width: 24,
    height: 24,
    transform: "translate(3004 -383)",
    fill: "#8a8a8a",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(-3004 383)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(3003.2 -383.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M16,12.8a3.2,3.2,0,1,1-3.2-3.2A3.2,3.2,0,0,1,16,12.8Z",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M19.741,7.059A12.15,12.15,0,0,0,12.788,4.8a11.733,11.733,0,0,0-6.33,1.924A21.337,21.337,0,0,0,.8,12.8a19.3,19.3,0,0,0,5.01,5.759,11.969,11.969,0,0,0,13.943,0A19.173,19.173,0,0,0,24.8,12.8,19.426,19.426,0,0,0,19.741,7.059ZM12.8,17.6a4.8,4.8,0,1,1,4.8-4.8A4.8,4.8,0,0,1,12.8,17.6Z",
    fill: "#8a8a8a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.3d7aa817c52bce434587f6e89fa1d735.svg";
export { ForwardRef as ReactComponent };